import React from "react";
import { twMerge } from "tailwind-merge";

interface ISwitch {
  checked: boolean;
  onChange?: (_value: boolean) => void;
  className?: string;
  label?: any;
  id?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  disabled?: boolean;
}
const sizeMap = {
  xs: { track: "w-8 h-4", thumb: "after:h-3 after:w-3", translate: "peer-checked:after:translate-x-full" },
  sm: { track: "w-9 h-5", thumb: "after:h-4 after:w-4", translate: "peer-checked:after:translate-x-full" },
  md: { track: "w-11 h-6", thumb: "after:h-5 after:w-5", translate: "peer-checked:after:translate-x-full" },
  lg: { track: "w-16 h-7", thumb: "after:h-6 after:w-6", translate: "peer-checked:after:translate-x-[2.25rem]" },
  xl: { track: "w-20 h-8", thumb: "after:h-7 after:w-7", translate: "peer-checked:after:translate-x-[3rem]" },
};

export function Switch({
  checked = false,
  onChange = () => {},
  className,
  label,
  id,
  size = "md",
  disabled = false,
}: ISwitch) {
  const { track, thumb, translate } = sizeMap[size];

  return (
    <label className={twMerge("flex flex-col items-start ", className)}>
      {label && <span className="text-gray-500  text-sm flex-shrink-0">{label}</span>}
      <div
        // htmlFor="default-toggle"
        className="inline-flex items-center cursor-pointer"
      >
        <input
          type="checkbox"
          value=""
          id={id}
          className="peer hidden"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <div
          className={twMerge(
            `relative bg-gray-400 peer-focus:outline-none 
            rounded-full peer 
            peer-checked:after:translate-x-full
            after:content-[''] 
            after:absolute 
            after:top-[2px] 
            after:left-[2px] 
            after:bg-white 
            after:rounded-full 
            after:transition-all 
            peer-checked:bg-blue-600`,
            track,
            thumb,
            translate
          )}
        ></div>
      </div>
    </label>
  );
}
